var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPrivacy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "F\\xFCllung",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448.15,32H64A16,16,0,0,0,48,48V170c0,96.41,11.24,154.93,38.81,202,29.57,50.46,79.86,88.34,163.09,122.81a.85.85,0,0,0,.17.06q.62.26,1.26.45l.1,0c.44.13.89.24,1.34.33l.46.09,1,.14.46.05c.44,0,.88.06,1.33.06H256c.45,0,.89,0,1.33-.06l.46-.05,1-.14.47-.09c.44-.09.87-.2,1.31-.33l.14,0c.42-.13.83-.28,1.24-.44l.17-.07C345.36,460.3,395.68,422.43,425.27,372c27.62-47.07,38.88-105.59,38.88-202V48A16,16,0,0,0,448.15,32ZM397.67,355.79c-25.14,42.85-69,76-141.67,106.85-72.67-30.88-116.49-64-141.6-106.85C90,314.07,80,260.25,80,170V64H432.15V170C432.15,260.22,422.16,314,397.67,355.79Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.89,93a16,16,0,0,0-21.7,6.41L225,338.69,174.9,272.11a16,16,0,0,0-25.58,19.23l65,86.47a16,16,0,0,0,12.78,6.38c.39,0,.78,0,1.18,0a16,16,0,0,0,12.88-8.31L383.29,114.7A16,16,0,0,0,376.89,93Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacy);
export default __webpack_public_path__ + "static/media/icon-privacy.b73e4b6b.svg";
export { ForwardRef as ReactComponent };